/* eslint-disable no-promise-executor-return */
import { v4 as uuidv4 } from 'uuid';

export default {
  async CREATE_userFile({ commit, state }, userFile) {
    await new Promise((r) => setTimeout(r, 2000)); // simulate waiting for network
    // eslint-disable-next-line no-param-reassign
    userFile.id = uuidv4();
    const { userFiles } = state;
    userFiles.push(userFile);
    commit('SET_userFiles', userFiles);
    return userFile;
  },
  async LOAD_userFiles() {
    await new Promise((r) => setTimeout(r, 2000)); // simulate waiting for network
  },
  async LOAD_userFile({ commit, state }, id) {
    await new Promise((r) => setTimeout(r, 2000)); // simulate waiting for network
    const { userFiles } = state;
    const userFile = userFiles.find((item) => item.id === id);
    commit('SET_userFile', userFile);
  },
  async UPDATE_userFile() {
    await new Promise((r) => setTimeout(r, 2000)); // simulate waiting for network
  },
  async DELETE_userFile({ commit, state }, userFile) {
    await new Promise((r) => setTimeout(r, 2000)); // simulate waiting for network
    const { userFiles } = state;
    const index = userFiles.indexOf(userFile);
    if (index > -1) {
      userFiles.splice(index, 1);
    }
    commit('SET_userFiles', userFiles);
  },
};
